import { TrackContactCreationState } from '../../types/trackContactCreation/trackContactCreation.types';
import {
  GET_TRACK_CONTACT_CREATION_REQUEST,
  GET_TRACK_CONTACT_CREATION_SUCCESS,
  GET_TRACK_CONTACT_CREATION_FAILURE,
  CLEAR_TRACK_CONTACT_CREATION_STATE,
  TrackContactCreationActionTypes,
} from './trackContactCreation.types';

const initialState: TrackContactCreationState = {
  trackContactCreations: [],
  loading: false,
  error: null,
  pagination: {
    page: 0,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
};

const trackContactCreationReducer = (
  state: TrackContactCreationState = initialState,
  action: TrackContactCreationActionTypes
): TrackContactCreationState => {
  switch (action.type) {
    case GET_TRACK_CONTACT_CREATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_TRACK_CONTACT_CREATION_SUCCESS:
      return {
        ...state,
        loading: false,
        trackContactCreations:
          action.payload.data || action.payload.trackContactCreations || [],
        pagination: action.payload.pagination,
        error: null,
      };

    case GET_TRACK_CONTACT_CREATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CLEAR_TRACK_CONTACT_CREATION_STATE:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default trackContactCreationReducer;
